import { Type } from 'class-transformer';
import { ArrayMinSize, IsArray } from 'class-validator';

export class UpdateItemDeliveryOptionsModel {
  @IsArray()
  @ArrayMinSize(1)
  @Type(() => Number)
  public selected: number[];

  public constructor(selected: number[]) {
    this.selected = selected;
  }
}
